/* Dr.Shampoo — página de produto: galeria, quantidade/preço dinâmico,
   comprar já, estimativa de entrega, upsell "A Combinação Perfeita",
   barra sticky, recomendações e vistos recentemente. */
(function () {
  'use strict';

  var D = document;
  var fmt = window.dsFmtMoney;
  var S = window.dsStrings || {};
  var LOCALE = window.dsLocale || 'pt-PT';
  var qty = 1;

  function currentVid() {
    var atc = D.querySelector('[data-ds-buy] [data-ds-atc]');
    return atc ? parseInt(atc.getAttribute('data-vid'), 10) : null;
  }
  function currentPrice() {
    var atc = D.querySelector('[data-ds-buy] [data-ds-atc]');
    return atc ? parseInt(atc.getAttribute('data-price'), 10) : 0;
  }
  function updateAtcTotal() {
    var value = fmt(currentPrice() * qty);
    var total = D.querySelector('[data-ds-atc-total]');
    if (total) total.textContent = value;
    var subtotal = D.querySelector('[data-ds-subtotal]');
    if (subtotal) subtotal.textContent = value;
  }

  /* ---------- Galeria ---------- */
  D.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-ds-thumb]');
    if (!thumb) return;
    var main = D.getElementById('ds-gallery-main');
    if (!main) return;
    main.src = thumb.getAttribute('data-src');
    main.srcset = thumb.getAttribute('data-srcset');
    D.querySelectorAll('[data-ds-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* ---------- Quantidade ---------- */
  D.addEventListener('ds:qty', function (e) {
    qty = e.detail.qty;
    updateAtcTotal();
  });

  /* ---------- Variantes ---------- */
  var select = D.querySelector('[data-ds-variant-select]');
  if (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var price = parseInt(opt.getAttribute('data-price'), 10);
      var compare = parseInt(opt.getAttribute('data-compare'), 10);
      D.querySelectorAll('[data-ds-atc]').forEach(function (b) {
        b.setAttribute('data-vid', opt.value);
        b.setAttribute('data-price', price);
      });
      var priceEl = D.querySelector('[data-ds-price]');
      if (priceEl) priceEl.textContent = fmt(price);
      var up = D.querySelector('[data-ds-unitprice]');
      if (up) {
        up.setAttribute('data-price', price);
        fillUnitPrice();
      }
      var klarna = D.querySelector('[data-ds-klarna-amount]');
      if (klarna) {
        var inst = parseInt(klarna.getAttribute('data-installments'), 10) || 3;
        klarna.textContent = fmt(Math.round(price / inst));
      }
      var oldEl = D.querySelector('.ds-pinfo__old');
      if (oldEl) oldEl.textContent = compare > price ? fmt(compare) : '';
      updateAtcTotal();
    });
  }

  /* ---------- Adicionar ao carrinho / Comprar já ---------- */
  D.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-ds-atc]');
    if (atc) {
      atc.disabled = true;
      window.dsAddItems([{ id: parseInt(atc.getAttribute('data-vid'), 10), quantity: qty }]).then(function () {
        atc.disabled = false;
      });
      return;
    }
    var buynow = e.target.closest('[data-ds-buynow]');
    if (buynow) {
      buynow.disabled = true;
      window
        .dsAddItems([{ id: currentVid(), quantity: qty }], { quiet: true, message: S.preparing_checkout || 'A preparar o checkout…' })
        .then(function (res) {
          if (res) window.location.href = '/checkout';
          else buynow.disabled = false;
        });
    }
  });

  /* ---------- Stock + preço por unidade ---------- */
  function fillUnitPrice() {
    var el = D.querySelector('[data-ds-unitprice]');
    if (!el) return;
    var price = parseInt(el.getAttribute('data-price'), 10);
    var title = el.getAttribute('data-title') || '';
    var ref = el.getAttribute('data-ref') || '100ml';
    var tax = el.getAttribute('data-tax') || '';
    var m = title.match(/(\d+(?:[.,]\d+)?)\s*(ml|cl|kg|grs?|gramas?|g|l)(?![a-z])/i);
    if (!m) {
      el.textContent = '';
      return;
    }
    var qty = parseFloat(m[1].replace(',', '.'));
    var unit = m[2].toLowerCase();
    var family = unit === 'kg' || unit.charAt(0) === 'g' ? 'mass' : 'vol';
    var factor = unit === 'l' || unit === 'kg' ? 1000 : unit === 'cl' ? 10 : 1;
    var base = qty * factor;
    if (base <= 0) {
      el.textContent = '';
      return;
    }
    /* A referência configurada define a escala (100 ou 1000); a família
       segue o produto: 100ml↔100g e 1l↔1kg. */
    var refQty = ref === '1l' || ref === '1kg' ? 1000 : 100;
    var label = family === 'mass' ? (refQty === 1000 ? '1 kg' : '100 g') : (refQty === 1000 ? '1 L' : '100 ml');
    el.textContent = fmt(Math.round((price / base) * refQty)) + ' / ' + label + ' ' + tax;
  }
  fillUnitPrice();

  /* ---------- Estimativa de entrega ---------- */
  (function delivery() {
    var box = D.querySelector('[data-ds-delivery]');
    if (!box) return;
    var dfmt = new Intl.DateTimeFormat(LOCALE, { weekday: 'long', day: 'numeric', month: 'short' });
    function businessDate(addDays) {
      var d = new Date();
      var added = 0;
      while (added < addDays) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) added++;
      }
      return dfmt.format(d);
    }
    var start = box.querySelector('[data-ds-delivery-start]');
    var end = box.querySelector('[data-ds-delivery-end]');
    if (start) start.textContent = businessDate(parseInt(box.getAttribute('data-min'), 10) || 3);
    if (end) end.textContent = businessDate(parseInt(box.getAttribute('data-max'), 10) || 5);
  })();

  /* ---------- Upsell "A Combinação Perfeita" ---------- */
  (function bundle() {
    var root = D.querySelector('[data-ds-bundle]');
    if (!root) return;
    var totalEl = root.querySelector('[data-ds-bundle-total]');
    var pvprEl = root.querySelector('[data-ds-bundle-pvpr]');
    var saveEl = root.querySelector('[data-ds-bundle-save]');
    var addBtn = root.querySelector('[data-ds-bundle-add]');

    /* Modo automático: sugestões da Shopify (complementares → relacionados) */
    if (root.hasAttribute('data-ds-bundle-auto')) {
      var recosUrl = root.getAttribute('data-recos-url');
      var max = parseInt(root.getAttribute('data-max'), 10) || 2;
      var currentId = (recosUrl.match(/product_id=(\d+)/) || [])[1];
      var list = root.querySelector('[data-ds-bundle-list]');

      function fetchRecos(intent) {
        return fetch(recosUrl + '&intent=' + intent)
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (data) { return data.products || []; })
          .catch(function () { return []; });
      }
      function bundleRow(p) {
        var v = p.variants && p.variants[0];
        if (!v) return '';
        var old = p.compare_at_price && p.compare_at_price > p.price ? p.compare_at_price : p.price;
        var img = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=116';
        return '<div><div class="ds-bundle__plus">+</div><div class="ds-bundle__row">' +
          '<button class="ds-bundle__check" type="button" role="checkbox" aria-checked="true" data-ds-bundle-check' +
          ' data-vid="' + v.id + '" data-price="' + p.price + '" data-old="' + old + '" aria-label="' + (S.include_item || 'Incluir %s').replace('%s', p.title.replace(/"/g, '&quot;')) + '">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>' +
          '<img src="' + img + '" width="58" height="58" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' +
          '<div style="min-width:0">' +
          '<div class="ds-bundle__title"><a href="' + p.url + '">' + p.title + '</a></div>' +
          '<div class="ds-bundle__prices"><span class="ds-bundle__price">' + fmt(p.price) + '</span>' +
          (old > p.price ? '<span class="ds-bundle__pvpr">' + (S.rrp || 'PVPR') + ' <s>' + fmt(old) + '</s></span>' : '') +
          '</div></div></div></div>';
      }
      fetchRecos('complementary').then(function (products) {
        if (products.length > 0) return products;
        return fetchRecos('related');
      }).then(function (products) {
        var rows = '';
        var added = 0;
        (products || []).forEach(function (p) {
          if (added >= max) return;
          if (String(p.id) === currentId || !p.available || !p.featured_image) return;
          var html = bundleRow(p);
          if (html) {
            rows += html;
            added++;
          }
        });
        if (added > 0 && list) {
          list.insertAdjacentHTML('beforeend', rows);
          root.hidden = false;
          recompute();
        }
      });
    }

    function selected() {
      return Array.prototype.filter.call(root.querySelectorAll('[data-ds-bundle-check]'), function (c) {
        return c.getAttribute('aria-checked') === 'true';
      });
    }
    function recompute() {
      var sel = selected();
      var total = 0;
      var pvpr = 0;
      sel.forEach(function (c) {
        total += parseInt(c.getAttribute('data-price'), 10);
        pvpr += parseInt(c.getAttribute('data-old'), 10);
      });
      if (totalEl) totalEl.textContent = fmt(total);
      if (pvprEl) pvprEl.textContent = fmt(pvpr);
      if (saveEl) {
        if (pvpr > total) {
          var pct = Math.round((1 - total / pvpr) * 100);
          saveEl.textContent = (S.bundle_save || '%amount% a menos sobre o PVPR (-%percent%%)')
            .replace('%amount%', fmt(pvpr - total))
            .replace('%percent%', pct);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
      if (addBtn) {
        if (sel.length > 0) {
          addBtn.textContent = sel.length === 1
            ? (S.bundle_add_one || 'Adicionar 1 produto ao carrinho')
            : (S.bundle_add_other || 'Adicionar 999999 produtos ao carrinho').replace('999999', sel.length);
          addBtn.hidden = false;
        } else {
          addBtn.hidden = true;
        }
      }
    }
    root.addEventListener('click', function (e) {
      var check = e.target.closest('[data-ds-bundle-check]');
      if (check) {
        var on = check.getAttribute('aria-checked') === 'true';
        check.setAttribute('aria-checked', on ? 'false' : 'true');
        recompute();
        return;
      }
      if (e.target.closest('[data-ds-bundle-add]')) {
        var items = selected().map(function (c) {
          return { id: parseInt(c.getAttribute('data-vid'), 10), quantity: 1 };
        });
        if (items.length) window.dsAddItems(items);
      }
    });
    recompute();
  })();

  /* ---------- Barra sticky: visível quando o botão nativo não está no viewport ---------- */
  (function sticky() {
    var bar = D.querySelector('[data-ds-sticky]');
    var buy = D.querySelector('[data-ds-buy]');
    if (!bar || !buy) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        },
        { rootMargin: '-80px 0px 0px 0px' }
      );
      io.observe(buy);
    } else {
      bar.classList.add('is-visible');
    }
  })();

  /* ---------- Recomendações ("Outros clientes também compraram") ---------- */
  (function recos() {
    var host = D.querySelector('[data-ds-recos]');
    if (!host || host.querySelector('.ds-card')) return;
    fetch(host.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tpl = D.createElement('template');
        tpl.innerHTML = html;
        var fresh = tpl.content.querySelector('[data-ds-recos]');
        if (fresh) host.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  })();

  /* ---------- Vistos recentemente ---------- */
  (function recent() {
    var KEY = 'ds:viewed';
    var host = D.querySelector('[data-ds-recent]');
    var current = host ? host.getAttribute('data-current') : null;
    var list = [];
    try {
      list = JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (err) {
      list = [];
    }

    if (host) {
      var grid = host.querySelector('[data-ds-recent-grid]');
      var recentLimit = parseInt(host.getAttribute('data-limit'), 10) || 4;
      var others = list.filter(function (h) { return h !== current; }).slice(0, recentLimit);
      if (others.length > 0 && grid) {
        Promise.all(
          others.map(function (h) {
            return fetch('/products/' + h + '.js').then(function (r) {
              return r.ok ? r.json() : null;
            }).catch(function () { return null; });
          })
        ).then(function (products) {
          var html = '';
          products.forEach(function (p) {
            html += window.dsBuildCard(p, { atc: true, wish: false });
          });
          if (html) {
            grid.innerHTML = html;
            host.hidden = false;
          }
        });
      }
    }

    if (current) {
      var next = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, 12);
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch (err) { /* quota */ }
    }
  })();

  updateAtcTotal();
})();
